import { MDBBtn, MDBIcon } from "mdbreact"
import React, { Component } from "react"
import ReactApexChart from "react-apexcharts"
import { Link } from "react-router-dom"
import Select from 'react-select'
import { Card, CardBody, CardTitle, Col, Collapse, Container, Input, Label, Media, Row } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"


const options = {

    //labels: ["No asignado", "Asignado", "Planificado", "Aceptado", "Concluido", "Rechazado", "En proceso"],
    /*
     No Asignado......0 = Naranja
     Asignado.........1 = Amarillo
     Planificado......2 = Celeste
     Concluido........3 = Morado
     Aceptado.........4 = Verde
     Rechazado........5 = Rojo
     En proceso........6 = Gris
    */
    labels: ["No asignado", "Asignado", "Planificado", "Concluido", "Aceptado", "Rechazado", "En proceso"],

    colors: ["#ff6600", "#e5be01", "#B2FFFF", "#00FF00", "#572364","#FF0000","#808080"],

    legend: {
        show: !0,
        position: 'bottom',
        horizontalAlign: 'center',
        verticalAlign: 'middle',
        floating: !1,
        fontSize: '50px',
        offsetX: 0
    },
}

export default class grafica extends Component {
    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                titulo: "",
                descripcion: "",
                url_img_ns: "url_temp",
                img_nueva_solicitud: null,
                estado: 0,
                prioridad: 0,
                solicitar_a: null,
                lugar_ubicacion: null,
                tipo_solicitud: null,
                proyecto: null,
                colaborador: null,
                fecha_programada: null,
                fecha_fin: null,
                horas: 0,
                razon_rechazo: null,
                valor: 0,
                img_calificacion: null
            },
            fechaFin: null,
            fechaMin: null,
            solicitar_a: null,
            lugar_ubicacion: null,
            tipo_solicitud: null,
            ubicaciones: [],
            tiposSolicitudes: [],
            departamentosAreas: [],
            colapsar: true,
            solicitudes: [],
            serie: [0, 0, 0, 0, 0, 0, 0],
            options
        };
        this.buscar = this.buscar.bind(this);
        this.getInformacion = this.getInformacion.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);

    }

    componentDidMount() {
        this.getInformacion();
        let id = null;
        if (this.apiRest.getRol()) {
            this.getDepartamentoArea();
        } else {
            id = this.apiRest.getLS('du').colaborador.id;
            this.obtenerDepartamentoLoggeado(id);
        }
        localStorage.removeItem("items");
    }

    cambiosUbicacion = lugar => {
        this.setState({ lugar_ubicacion: lugar });
    }

    cambiosSolicitarA = asignado => {
        this.setState({ solicitar_a: asignado });
        if (_valid(asignado)) {
            this.getTipoSolicitud(asignado.value);
        } else {
            this.setState({ tiposSolicitudes: [] });
        }
    }

    getTipoSolicitud = (id) => {
        //obtener tipo de solicitudes
        this.apiRest.get('/tipoSolicitudPorDepartamento/' + id).then(resultado => {
            if (resultado.exitoso) {
                this.setState({ tiposSolicitudes: this.formato(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    cambiosSolicitud = solicitud => {
        this.setState({ tipo_solicitud: solicitud });
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            ...estadoAnterior, [name]: value
        }));
    }

    //formatear la seleccion
    formato = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));
    formatoUbicacion = valores => valores.data.map(i => ({ value: i.id, label: i.ubicacion_texto }));

    //traer informacion para los select de la vista
    getInformacion = () => {
        //obtener tipo de solicitud
        /*this.apiRest.get('/tipoSolicitud').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ tiposSolicitudes: this.formato(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });*/
        //obtener ubicacion
        if (this.apiRest.getRol()) {
            this.apiRest.get('/ubicacion').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ ubicaciones: this.formatoUbicacion(resultado) });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    getDepartamentoArea = () => {
        //obtener departamento
        this.apiRest.get('/departamentoArea').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentosAreas: this.formatoTexto(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    obtenerDepartamentoLoggeado = (id) => {
        if (_valid(id)) {
            this.apiRest.get('/departamentoLoggeado/' + id).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ departamentosAreas: this.formatoLabel(resultado) });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    formatoLabel = valores => valores.data.map(i => ({ value: i.id_departamento, label: i.departamento }));
    formatoTexto = valores => valores.data.map(i => ({ value: i.id, label: i.texto_area }));

    //metodo para extraer los valores de los estados para usar en la grafica
    valor = (solicitudes) => {

        let valores = [0, 0, 0, 0, 0, 0, 0];
        if (Object.keys(solicitudes).length === 0) {
            toastr.error('Vaya! No se encontro informacion, por favor intenta nuevamente.');
        } else {
            toastr.success('Procesando solicitud espere un momento por favor');
            solicitudes.forEach(function (solicitud, index) {
                /*
                 No Asignado......0 = Naranja
                 Asignado.........1 = Amarillo
                 Planificado......2 = Celeste
                 Concluido........3 = Morado
                 Aceptado.........4 = Verde
                 Rechazado........5 = Rojo
                 En proceso........6 = Gris
                */
                switch (solicitud.estado) {
                    case 0:
                        //no asignado
                        valores[0] += 1;
                        break;
                    case 1:
                        //asignado
                        valores[1] += 1;
                        break;
                    case 2:
                        //planificado
                        valores[2] += 1;
                        break;
                    case 3:
                        //aceptado
                        valores[3] += 1;
                        break;
                    case 4:
                        //concluido
                        valores[4] += 1;
                        break;
                    case 5:
                        //rechazado
                        valores[5] += 1;
                        break;
                    case 6:
                        //En proceso
                        valores[6] += 1;
                        break;
                    default:
                        break;
                }
            });
        }
        this.setState({ serie: valores });
    }

    validar = (filtro) => {
        let boleano = false;
        for (const property in filtro) {
            if (_valid(filtro[property])) {
                return boleano = true
            }
        }
        return boleano;
    }

    //metodo para buscar la data filtrada
    buscar = async () => {
        const {
            fechaMin,
            fechaFin,
            solicitar_a,
            lugar_ubicacion,
            tipo_solicitud
        } = this.state
        let solicitar = null;
        let lugar = null;
        let tipo = null;
        if (solicitar_a !== null) {
            solicitar = solicitar_a.value;
        }

        if (lugar_ubicacion !== null) {
            lugar = lugar_ubicacion.value;
        }
        if (tipo_solicitud !== null) {
            tipo = tipo_solicitud.value;
        }

        const filtro = {
            fechaMin,
            fechaFin,
            solicitar,
            lugar,
            tipo
        }

        if (this.validar(filtro)) {
            this.apiRest.put('/solicitudFiltrar', filtro).then(respuesta => {
                if (respuesta.exitoso) {
                    this.valor(respuesta.data)
                    window.localStorage.setItem('items', JSON.stringify(respuesta.data));
                } else {
                    let valores = [0, 0, 0, 0, 0, 0, 0];
                    this.setState({ serie: valores });
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        } else {
            let valores = [0, 0, 0, 0, 0, 0, 0];
            this.setState({ serie: valores });
            localStorage.removeItem("items");
            toastr.error('Elije una opcion, por favor intenta nuevamente.');
        }
    }

    //descarga de excel grafica
    descargarExcel = () => {
        let result = JSON.parse(localStorage.getItem('items'));
        console.log(result);
        if (_valid(result)) {
            this.exportarData(result);
            localStorage.removeItem("items");
        } else {
            toastr.error('No hay datos para procesados realize una busqueda primero');
        }
    }

    //metodo para exportar los datos a graficar
    exportarData = (datos) => {
        let array = null;
        array = datos
        if (_valid(array)) {
            const auth = this.apiRest.getLS('authUser');
            if (auth !== null) {
                const headers = {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                    responseType: 'blob',
                    body: JSON.stringify(datos ? datos : '')
                }
                fetch(process.env.REACT_APP_API_URL + "/graficaCalificacion/" + 2, headers).then(resp => {
                    if (resp.status >= 200 && resp.status < 300) {
                        resp.blob().then(blob => {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement("a");
                            a.style.display = "none";
                            a.href = url;
                            // the filename you want
                            a.download = "grafica.xlsx";
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                        });
                    } else if (resp.status === 401) {
                        this.props.history.push('/Timeout');
                    }
                });
            } else {
                toastr.error('Vaya! No loggeado, por favor intenta nuevamente.');
            }
        } else {
            toastr.error('No hay datos para procesar');
        }
    }

    borrarFiltros = () => {
        this.setState({ fechaFin: null, fechaMin: null, lugar_ubicacion: null, solicitar_a: null, tipo_solicitud: null })
        this.setState({ fechaFin: '', fechaMin: '', lugar_ubicacion: '', solicitar_a: '', tipo_solicitud: '' })
    }

    render() {
        const {
            colapsar,
            fechaMin,
            fechaFin,
            departamentosAreas,
            tiposSolicitudes,
            ubicaciones,
            solicitar_a,
            lugar_ubicacion,
            tipo_solicitud,
            serie
        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Mesa de Servicio" breadcrumbItem="Gráfica de Solicitudes por Estado" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Gr&aacute;fica</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, seleccione una opci&oacute;n.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <form>
                                                <div className="p-4 border-top">
                                                    <Row>
                                                        <Col lg={3}>
                                                            <Label htmlFor="fechaMin" className="form-label">
                                                                Desde la fecha
                                                            </Label>
                                                            <Input
                                                                value={fechaMin}
                                                                onChange={this.actualizarValores}
                                                                name="fechaMin"
                                                                type="date"
                                                            />
                                                        </Col>
                                                        <Col lg={3}>
                                                            <Label htmlFor="fechaFin" className="form-label">
                                                                Hasta la fecha
                                                            </Label>
                                                            <Input
                                                                value={fechaFin}
                                                                onChange={this.actualizarValores}
                                                                name="fechaFin"
                                                                type="date"
                                                            />
                                                        </Col>
                                                        <Col lg={3}>
                                                            <Label htmlFor="solicitar_a" className="form-label">
                                                                Departamento/Área
                                                            </Label>
                                                            <Select
                                                                name="solicitar_a"
                                                                options={departamentosAreas}
                                                                value={solicitar_a}
                                                                onChange={this.cambiosSolicitarA}
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                placeholder="Selecciona.."
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                noOptionsMessage={() => "No hay más opciones"}
                                                            />
                                                        </Col>
                                                        {
                                                            this.apiRest.getRol() ?
                                                                <Col lg={3}>
                                                                    <Label htmlFor="lugar_ubicacion" className="form-label">
                                                                        Ubicación
                                                                    </Label>
                                                                    <Select
                                                                        name="lugar_ubicacion"
                                                                        options={ubicaciones}
                                                                        value={lugar_ubicacion}
                                                                        onChange={this.cambiosUbicacion}
                                                                        className="basic-single"
                                                                        classNamePrefix="select"
                                                                        placeholder="Selecciona.."
                                                                        isClearable={true}
                                                                        isSearchable={true}
                                                                        noOptionsMessage={() => "No hay más opciones"}
                                                                    />
                                                                </Col>
                                                                : ''
                                                        }
                                                    </Row>
                                                    <p />
                                                    <Row>
                                                        <Col lg={3}>
                                                            <Label htmlFor="tipo_solicitud" className="form-label">
                                                                Tipo de Solicitud
                                                            </Label>
                                                            <Select
                                                                name="tipo_solicitud"
                                                                options={tiposSolicitudes}
                                                                value={tipo_solicitud}
                                                                onChange={this.cambiosSolicitud}
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                placeholder="Selecciona.."
                                                                isClearable={true}
                                                                isSearchable={true}
                                                                noOptionsMessage={() => "No hay más opciones"}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <p />
                                                    <Row>
                                                        <Row>
                                                            <Col>
                                                                <MDBBtn className="waves-effect" color="success" onClick={this.buscar}>
                                                                    <MDBIcon icon="fas fa-search" />{' '}
                                                                    Buscar
                                                                </MDBBtn>
                                                                {' '}
                                                                <MDBBtn className="waves-effect" color="success" onClick={this.descargarExcel}>
                                                                    <MDBIcon icon="fas fa-book" />{' '}
                                                                    Exportar
                                                                </MDBBtn>
                                                                {' '}
                                                                <MDBBtn className="waves-effect" color="warning" onClick={this.borrarFiltros}>
                                                                    <MDBIcon icon="fas fa-trash-alt" />{' '}
                                                                    Borrar Filtros
                                                                </MDBBtn>
                                                            </Col>
                                                        </Row>
                                                    </Row>
                                                    {' '}
                                                </div>
                                            </form>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="mb-4">Grafica de solicitudes</CardTitle>
                                        <ReactApexChart
                                            options={this.state.options}
                                            series={serie}
                                            type="pie"
                                            height="350"
                                            className="apex-charts"
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} className="text-end">
                                <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/dashboard') }}>
                                    <MDBIcon icon="fas fa-arrow-left" />{' '}
                                    Regresar
                                </MDBBtn>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}